import React, { useEffect, useState } from "react";
import { Flex, Radio } from "antd";
import { toast } from "react-toastify";
import { Table } from "antd";
import { customLogger } from "../../../utils/Logger";
import { useThemeContext } from "../../../context/ThemeContext";
import CustomLoader from "../../../components/common/UI/Loader";
import ENDPOINTS from "../../../services/endpoint";
import apiInstance from "../../../services/apiService";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import "./index.scss";

interface MinutesUsageProps {
  handleBackToPrevious: () => void;
}

interface tableData {
  addonName: string;
  addonStatus: boolean;
  addonType: number;
  countryNames: string[];
  remaining: number;
  total: number;
  used: number;
}
const MinutesUsage: React.FC<MinutesUsageProps> = ({
  handleBackToPrevious,
}) => {
  const { theme } = useThemeContext();
  const [value, setValue] = useState<string>("calls");
  const [loading, setLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<tableData[]>([]);
  const [callData, setCallData] = useState<tableData[]>([]);
  const [smsData, setSMSData] = useState<tableData[]>([]);

  const handleChange = (e: any) => {
    setValue(e.target.value);
  };

  const columns = [
    {
      title: "Country",
      dataIndex: "countryNames",
      key: "countryNames",
      render: (countries: string[]) => (
        <div>
          {countries.map((country) => (
            <div key={country}>{country}</div>
          ))}
        </div>
      ),
    },
    {
      title: "Addon",
      dataIndex: "addonName",
      key: "addonName",
    },
    {
      title: "Free",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Remaining",
      dataIndex: "remaining",
      key: "remaining",
    },
    {
      title: "Status",
      dataIndex: "addonStatus",
      key: "addonStatus",
      render: (status: boolean) => (
        <span style={{ color: status ? "green" : "red" }}>
          {status ? "Active" : "In Asctive"}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const getTableData = async () => {
      const url = ENDPOINTS.MINUTE_USAGE;
      setLoading(true);

      try {
        const response = await apiInstance.get(url);
        const data = response.data.data;
        setTableData(data);
      } catch (error) {
        customLogger(error);
        toast.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    getTableData();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) {
      setCallData(tableData.filter((item) => item.addonType === 1));
      setSMSData(tableData.filter((item) => item.addonType === 2));
    }
  }, [tableData]);

  return (
    <>
      <div className="minute-usage-sider">
        <SettingsSidebarHeader
          title="Minutes Usage"
          handleBackClick={handleBackToPrevious}
        />

        <Radio.Group
          value={value}
          onChange={handleChange}
          className="tabs-wrapper"
        >
          <Radio.Button
            className="tab-btn"
            value="calls"
            style={{
              background:
                value === "calls"
                  ? theme === "light"
                    ? "linear-gradient(rgb(196, 53, 200) 34.17%, rgb(94, 104, 240) 100%)"
                    : "#DBE3F8"
                  : "transparent",
              color:
                value === "calls" ? (theme === "light" ? "#fff" : "#000") : "",
            }}
          >
            Calls
          </Radio.Button>

          <Radio.Button
            className="tab-btn"
            value="sms"
            style={{
              background:
                value === "sms"
                  ? theme === "light"
                    ? "linear-gradient(rgb(196, 53, 200) 34.17%, rgb(94, 104, 240) 100%)"
                    : "#DBE3F8"
                  : "transparent",
              color:
                value === "sms" ? (theme === "light" ? "#fff" : "#000") : "",
            }}
          >
            SMS
          </Radio.Button>
        </Radio.Group>

        <div className="table-container">
          <Table
            rowHoverable={false}
            columns={columns}
            dataSource={value === "calls" ? callData : smsData}
            rowKey="addonName"
            loading={{
              spinning: loading,
              indicator: (
                <Flex className="h-full w-full" justify="center" align="center">
                  <CustomLoader />
                </Flex>
              ),
            }}
            pagination={false}
            bordered={false}
            className="custom-table"
          />
        </div>
      </div>
    </>
  );
};

export default MinutesUsage;
